// extracted by mini-css-extract-plugin
export var subtitle = "_b4-2";
export var title = "_b4-0";
export var titleNoWrap = "_b4-1";